import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';
import axios from 'axios';
import Constants from './constants';
import { EventBus } from './event-bus';
import RouterHelper from '@/helpers/route.helper';
import Home from '@/pages/home/Index.vue';
import Error404 from '@/pages/errors/404.vue';
import Error403 from '@/pages/errors/403.vue';
import Login from '@/pages/login/Index.vue';
import Password from '@/pages/login/Password.vue';
import ChangePassword from '@/pages/login/ChangePassword.vue';
import ProfileEdit from '@/pages/profile/Edit.vue';
import Settings from '@/pages/settings/Index.vue';
import SettingEdit from '@/pages/settings/Edit.vue';
import Patients from '@/pages/patients/Index.vue';
import PatientEdit from '@/pages/patients/Edit.vue';
import Donors from '@/pages/donors/Index.vue';
import DonorEdit from '@/pages/donors/Edit.vue';
import UpdateDonorsState from '@/pages/donors/UpdateDonorsState.vue';
import DonorsAtWork from '@/pages/donorsAtWork/Index.vue';
import DonorsAtWorkEdit from '@/pages/donorsAtWork/Edit.vue';
import DonorsRelative from '@/pages/donorsRelative/Index.vue';
import DonorsRelativeEdit from '@/pages/donorsRelative/Edit.vue';
import DonorsForm from '@/pages/donorsForm/Index.vue';
import DonorsFormEdit from '@/pages/donorsForm/Edit.vue';
import Users from '@/pages/users/Index.vue';
import UserEdit from '@/pages/users/Edit.vue';
import Actions from '@/pages/actions/Index.vue';
import ActionEdit from '@/pages/actions/Edit.vue';
import Services from '@/pages/services/Index.vue';
import ServiceEdit from '@/pages/services/Edit.vue';
import ComplexServices from '@/pages/complexServices/Index.vue';
import ComplexServiceEdit from '@/pages/complexServices/Edit.vue';
import Organizations from '@/pages/organizations/Index.vue';
import OrganizationEdit from '@/pages/organizations/Edit.vue';
import Reasons from '@/pages/reasons/Index.vue';
import ReasonEdit from '@/pages/reasons/Edit.vue';
import ValidLocuses from '@/pages/valid_locuses/Index.vue';
import ValidLocusEdit from '@/pages/valid_locuses/Edit.vue';
import Timeouts from '@/pages/timeouts/Index.vue';
import TimeoutEdit from '@/pages/timeouts/Edit.vue';
import Roles from '@/pages/roles/Index.vue';
import RoleEdit from '@/pages/roles/Edit.vue';
import Diagnoses from '@/pages/diagnoses/Index.vue';
import DiagnosisEdit from '@/pages/diagnoses/Edit.vue';
import Regions from '@/pages/regions/Index.vue';
import RegionsEdit from '@/pages/regions/Edit.vue';
import SocialNetworks from '@/pages/socialNetworks/Index.vue';
import SocialNetworksEdit from '@/pages/socialNetworks/Edit.vue';
import Diseases from '@/pages/diseases/Index.vue';
import DiseasesEdit from '@/pages/diseases/Edit.vue';
import RegisterJoinTypes from '@/pages/registerJoinTypes/Index.vue';
import RegisterJoinTypesEdit from '@/pages/registerJoinTypes/Edit.vue';
import LearnedFrom from '@/pages/learnedFrom/Index.vue';
import LearnedFromEdit from '@/pages/learnedFrom/Edit.vue';
import DataProcessingAgreements from '@/pages/dataProcessingAgreements/Index.vue';
import DataProcessingAgreementsEdit from '@/pages/dataProcessingAgreements/Edit.vue';
import EntryActions from '@/pages/entryActions/Index.vue';
import EntryActionsEdit from '@/pages/entryActions/Edit.vue';
import Nationalities from '@/pages/nationalities/Index.vue';
import NationalitiesEdit from '@/pages/nationalities/Edit.vue';
import EntryMedicalOffices from '@/pages/entryMedicalOffices/Index.vue';
import EntryMedicalOfficesEdit from '@/pages/entryMedicalOffices/Edit.vue';
import InitialDeletionReasons from '@/pages/initialDeletionReasons/Index.vue';
import InitialDeletionReasonsEdit from '@/pages/initialDeletionReasons/Edit.vue';
import DeletionReasons from '@/pages/deletionReasons/Index.vue';
import DeletionReasonsEdit from '@/pages/deletionReasons/Edit.vue';
import InaccessibilityReasons from '@/pages/inaccessibilityReasons/Index.vue';
import InaccessibilityReasonsEdit from '@/pages/inaccessibilityReasons/Edit.vue';
import Reports from '@/pages/reports/Index.vue';
import ExclusionReasons from '@/pages/exclusionReasons/Index.vue';
import ExclusionReasonsEdit from '@/pages/exclusionReasons/Edit.vue';
import PlanningTechnicalWork from '@/pages/planningTechnicalWork/Index.vue';
import PlanningTechnicalWorkEdit from '@/pages/planningTechnicalWork/Edit.vue';
import GroupGCodes from '@/pages/groupGCodes/Index.vue';
import GroupGCodesEdit from '@/pages/groupGCodes/Edit.vue';
import Mac from '@/pages/mac/Index.vue';
import MacEdit from '@/pages/mac/Edit.vue';
import MailTemplates from '@/pages/mailTemplates/Index.vue';
import MailTemplateEdit from '@/pages/mailTemplates/Edit.vue';
import Mailings from '@/pages/mailings/Index.vue';
import MailingEdit from '@/pages/mailings/Edit.vue';
import ReportTemplates from '@/pages/reportTemplates/Index.vue';
import ReportTemplateEdit from '@/pages/reportTemplates/Edit.vue';
import Localization from '@/pages/localization/Index.vue';
import LocalizationEdit from '@/pages/localization/Edit.vue';
import Certificate from '@/pages/certificate/Index.vue';
import CertificateEdit from '@/pages/certificate/Edit.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/UpdateDonorsState',
      name: 'UpdateDonorsState',
      component: UpdateDonorsState,
      meta: { auth: 'ProfileEdit' }
    },
    {
      path: '/profile',
      name: 'ProfileEdit',
      component: ProfileEdit,
      meta: { auth: 'ProfileEdit' },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/password',
      name: 'Password',
      component: Password,
    },
    {
      path: '/changePassword/:id',
      name: 'ChangePassword',
      component: ChangePassword,
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: { auth: 'Settings' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/settings/:id',
      name: 'SettingEdit',
      component: SettingEdit,
      meta: { auth: 'Settings' },
    },
    {
      path: '/mailTemplates',
      name: 'MailTemplates',
      component: MailTemplates,
      meta: { auth: 'MailTemplates' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/mailTemplates/:id',
      name: 'MailTemplateEdit',
      component: MailTemplateEdit,
      meta: { auth: 'MailTemplates' },
    },
    {
      path: '/mailings',
      name: 'Mailings',
      component: Mailings,
      meta: { auth: 'Certificate' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/Mailings/:id',
      name: 'MailingEdit',
      component: MailingEdit,
      meta: { auth: 'Certificate' },
    },
    {
      path: '/Mailings/copy/:id',
      name: 'MailingEdit',
      component: MailingEdit,
      meta: { auth: 'Certificate' },
    },
    {
      path: '/reportTemplates',
      name: 'ReportTemplates',
      component: ReportTemplates,
      meta: { auth: 'ReportTemplates' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/reportTemplates/:id',
      name: 'ReportTemplateEdit',
      component: ReportTemplateEdit,
      meta: { auth: 'ReportTemplates' },
    },
    {
      path: '/patients',
      name: 'Patients',
      component: Patients,
      props: (route) => ({ query: route.query }),
      meta: { auth: 'Patients' },
    },
    {
      path: '/patients/:id',
      name: 'PatientEdit',
      component: PatientEdit,
      meta: { auth: 'Patients' },
    },
    {
      path: '/patients/:id/:type',
      name: 'PatientEdit',
      component: PatientEdit,
      meta: { auth: 'Patients' },
    },
    {
      path: '/donors',
      name: 'Donors',
      component: Donors,
      props: (route) => ({ query: route.query }),
      meta: { auth: 'Donors' },
    },
    {
      path: '/donors/:id',
      name: 'DonorEdit',
      component: DonorEdit,
      meta: { auth: 'Donors' },
    },
    {
      path: '/donorsAtWork',
      name: 'DonorsAtWork',
      component: DonorsAtWork,
      props: (route) => ({ query: route.query }),
      meta: { auth: 'DonorsAtWork' },
    },
    {
      path: '/donorsAtWork/:id/:patientId?',
      name: 'DonorsAtWorkEdit',
      component: DonorsAtWorkEdit,
      meta: { auth: 'DonorsAtWorkEdit' },
    },
    {
      path: '/donorsRelative',
      name: 'DonorsRelative',
      component: DonorsRelative,
      props: (route) => ({ query: route.query }),
      meta: { auth: 'DonorsRelative' },
    },
    {
      path: '/donorsRelative/:id',
      name: 'DonorsRelativeEdit',
      component: DonorsRelativeEdit,
      meta: { auth: 'DonorsRelativeEdit' },
    },
    {
      path: '/donorsForm',
      name: 'DonorsForm',
      component: DonorsForm,
      props: (route) => ({ query: route.query }),
      meta: { auth: 'DonorsForm' },
    },
    {
      path: '/donorsForm/:id',
      name: 'DonorsFormEdit',
      component: DonorsFormEdit,
      meta: { auth: 'DonorsFormEdit' },
    },
    {
      path: '/certificates',
      name: 'Certificate',
      component: Certificate,
      props: (route) => ({ query: route.query }),
      meta: { auth: 'Certificate' },
    },
    {
      path: '/certificates/:id',
      name: 'CertificateEdit',
      component: CertificateEdit,
      meta: { auth: 'CertificateEdit' },
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: { auth: 'Users' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/users/:id/:organizationId?',
      name: 'UserEdit',
      component: UserEdit,
      meta: { auth: 'Users' },
    },
    {
      path: '/actions',
      name: 'Actions',
      component: Actions,
      meta: { auth: 'Actions' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/actions/:id',
      name: 'ActionEdit',
      component: ActionEdit,
      meta: { auth: 'Actions' },
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
      meta: { auth: 'Services' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/services/:id',
      name: 'ServiceEdit',
      component: ServiceEdit,
      meta: { auth: 'Services' },
    },
    {
      path: '/complexServices',
      name: 'ComplexServices',
      component: ComplexServices,
      meta: { auth: 'ComplexServices' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/complexServices/:id',
      name: 'ComplexServiceEdit',
      component: ComplexServiceEdit,
      meta: { auth: 'ComplexServices' },
    },
    {
      path: '/organizations',
      name: 'Organizations',
      component: Organizations,
      meta: { auth: 'Organizations' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/organizations/:id',
      name: 'OrganizationEdit',
      component: OrganizationEdit,
      meta: { auth: 'Organizations' },
    },
    {
      path: '/reasons',
      name: 'Reasons',
      component: Reasons,
      meta: { auth: 'Reasons' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/reasons/:id',
      name: 'ReasonEdit',
      component: ReasonEdit,
      meta: { auth: 'Reasons' },
    },
    {
      path: '/validLocuses',
      name: 'ValidLocuses',
      component: ValidLocuses,
      meta: { auth: 'ValidLocuses' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/validLocuses/:id',
      name: 'ValidLocusEdit',
      component: ValidLocusEdit,
      meta: { auth: 'ValidLocuses' },
    },
    {
      path: '/timeouts',
      name: 'Timeouts',
      component: Timeouts,
      meta: { auth: 'Timeouts' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/timeouts/:id',
      name: 'TimeoutEdit',
      component: TimeoutEdit,
      meta: { auth: 'Timeouts' },
    },
    {
      path: '/roles',
      name: 'Roles',
      component: Roles,
      meta: { auth: 'Roles' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/roles/:id',
      name: 'RoleEdit',
      component: RoleEdit,
      meta: { auth: 'Roles' },
    },
    {
      path: '/diagnoses',
      name: 'Diagnoses',
      component: Diagnoses,
      meta: { auth: 'Diagnoses' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/diagnoses/:id',
      name: 'DiagnosisEdit',
      component: DiagnosisEdit,
      meta: { auth: 'Diagnoses' },
    },
    {
      path: '/regions',
      name: 'Regions',
      component: Regions,
      meta: { auth: 'Regions' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/regions/:id',
      name: 'RegionsEdit',
      component: RegionsEdit,
      meta: { auth: 'Regions' },
    },
    {
      path: '/socialNetworks',
      name: 'SocialNetworks',
      component: SocialNetworks,
      meta: { auth: 'SocialNetworks' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/socialNetworks/:id',
      name: 'SocialNetworksEdit',
      component: SocialNetworksEdit,
      meta: { auth: 'SocialNetworks' },
    },
    {
      path: '/diseases',
      name: 'Diseases',
      component: Diseases,
      meta: { auth: 'Diseases' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/diseases/:id',
      name: 'DiseasesEdit',
      component: DiseasesEdit,
      meta: { auth: 'Diseases' },
    },
    {
      path: '/registerJoinTypes',
      name: 'RegisterJoinTypes',
      component: RegisterJoinTypes,
      meta: { auth: 'RegisterJoinTypes' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/registerJoinTypes/:id',
      name: 'RegisterJoinTypesEdit',
      component: RegisterJoinTypesEdit,
      meta: { auth: 'RegisterJoinTypes' },
    },
    {
      path: '/learnedFrom',
      name: 'LearnedFrom',
      component: LearnedFrom,
      meta: { auth: 'LearnedFrom' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/learnedFrom/:id',
      name: 'LearnedFromEdit',
      component: LearnedFromEdit,
      meta: { auth: 'LearnedFrom' },
    },
    {
      path: '/dataProcessingAgreements',
      name: 'DataProcessingAgreements',
      component: DataProcessingAgreements,
      meta: { auth: 'DataProcessingAgreements' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/dataProcessingAgreements/:id',
      name: 'DataProcessingAgreementsEdit',
      component: DataProcessingAgreementsEdit,
      meta: { auth: 'DataProcessingAgreements' },
    },
    {
      path: '/entryActions',
      name: 'EntryActions',
      component: EntryActions,
      meta: { auth: 'EntryActions' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/entryActions/:id',
      name: 'EntryActionsEdit',
      component: EntryActionsEdit,
      meta: { auth: 'EntryActions' },
    },
    {
      path: '/nationalities',
      name: 'Nationalities',
      component: Nationalities,
      meta: { auth: 'Nationalities' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/nationalities/:id',
      name: 'NationalitiesEdit',
      component: NationalitiesEdit,
      meta: { auth: 'Nationalities' },
    },
    {
      path: '/entryMedicalOffices',
      name: 'EntryMedicalOffices',
      component: EntryMedicalOffices,
      meta: { auth: 'EntryMedicalOffices' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/entryMedicalOffices/:id',
      name: 'EntryMedicalOfficesEdit',
      component: EntryMedicalOfficesEdit,
      meta: { auth: 'EntryMedicalOffices' },
    },
    {
      path: '/initialDeletionReasons',
      name: 'InitialDeletionReasons',
      component: InitialDeletionReasons,
      meta: { auth: 'InitialDeletionReasons' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/initialDeletionReasons/:id',
      name: 'InitialDeletionReasonsEdit',
      component: InitialDeletionReasonsEdit,
      meta: { auth: 'InitialDeletionReasons' },
    },
    {
      path: '/deletionReasons',
      name: 'deletionReasons',
      component: DeletionReasons,
      meta: { auth: 'DeletionReasons' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/deletionReasons/:id',
      name: 'deletionReasonsEdit',
      component: DeletionReasonsEdit,
      meta: { auth: 'DeletionReasons' },
    },
    {
      path: '/reports',
      name: 'Reports',
      component: Reports,
      meta: { auth: 'Reports' },
    },
    {
      path: '/inaccessibilityReasons',
      name: 'InaccessibilityReasons',
      component: InaccessibilityReasons,
      meta: { auth: 'InaccessibilityReasons' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/inaccessibilityReasons/:id',
      name: 'InaccessibilityReasonsEdit',
      component: InaccessibilityReasonsEdit,
      meta: { auth: 'InaccessibilityReasons' },
    },
    {
      path: '/exclusionReasons',
      name: 'ExclusionReasons',
      component: ExclusionReasons,
      meta: { auth: 'ExclusionReasons' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/exclusionReasons/:id',
      name: 'ExclusionReasonsEdit',
      component: ExclusionReasonsEdit,
      meta: { auth: 'ExclusionReasons' },
    },
    {
      path: '/planningTechnicalWork',
      name: 'PlanningTechnicalWork',
      component: PlanningTechnicalWork,
      meta: { auth: 'PlanningTechnicalWork' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/planningTechnicalWork/:id',
      name: 'PlanningTechnicalWorkEdit',
      component: PlanningTechnicalWorkEdit,
      meta: { auth: 'PlanningTechnicalWork' },
    },
    {
      path: '/groupGCodes',
      name: 'GroupGCodes',
      component: GroupGCodes,
      meta: { auth: 'GroupGCodes' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/groupGCodes/:id',
      name: 'GroupGCodesEdit',
      component: GroupGCodesEdit,
      meta: { auth: 'GroupGCodes' },
    },
    {
      path: '/mac',
      name: 'Mac',
      component: Mac,
      meta: { auth: 'Mac' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/Mac/:id',
      name: 'MacEdit',
      component: MacEdit,
      meta: { auth: 'MacEdit' },
    },
    {
      path: '/localization',
      name: 'Localization',
      component: Localization,
      meta: { auth: 'Localization' },
      props: (route) => ({ query: route.query }),
    },
    {
      path: '/localization/:id',
      name: 'LocalizationEdit',
      component: LocalizationEdit,
      meta: { auth: 'Localization' },
    },
    { path: '/403', name: '403', component: Error403, meta: { auth: true } },
    { path: '*', component: Error404 },
  ],
});

axios.interceptors.request.use(
  (config: any) => {
    if (!/^(?:\w+:)\/\//.test(config.url)) {
      config.url = Constants.baseUrl + config.url;
    }
    const token = localStorage['rdkm_auth_token'];
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
    config.headers.common['Access-Control-Allow-Origin'] = `*`;
    config.headers.common['Language'] = localStorage.lang || 'Ru';
    config.headers.common['X-System'] = `RDKM-ZHJvb3QiLCJqdGkiOiI1ZDhkNTIyOC1mYTJiLTRl`;
    config.headers.common.Pragma = `no-cache`;

    return config;
  },
  (err: any) => {
    return Promise.reject(err);
  }
);

let showServerNotFoundMessage = true;
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function(error) {
    if (error && error.response && error.response.status == 401) {
      //@ts-ignore
      Vue.$auth.logout();
      EventBus.$emit('hideThrobber');
    }

    if(error && error.config && error.config.url.includes(Constants.statisticsUrl))
    {
      return Promise.reject(error.response);  
    }

    if (error.message === 'Network Error' && showServerNotFoundMessage) {
      showServerNotFoundMessage = false;
      setTimeout(function() {
        showServerNotFoundMessage = true;
      }, 1000);
      EventBus.$emit('error', { msg: 'Сервер недоступен' });
    }
    return Promise.reject(error.response);
  }
);

router.beforeEach((to: any, from: any, next: any) => {
  //@ts-ignore
  Vue.$auth.fetchUser().then((response) => {
    let auth = to.name;
    if(to.meta && typeof to.meta.auth == 'string') {
      auth = to.meta.auth;
    }
    if (response && response.data && !response.data.functionsRouteName.includes(auth) && !location.href.includes('403')) {
      next('/403');
    }
  });  
  
  next(); // make sure to always call next()!
  if (to.query && !to.query.take) {
    to.query.take = (window as any).pageSize;
  }
});

(Vue as any).router = router;

export default router;
